<template>
  <div class="container">
    <div class="iv-p-24 iv-text-center">
        <p class="iv-fs-16 iv-fc-65 iv-text-center">功能即将上线  敬请期待...</p>
        <img class="iv-m-t-8" style="height: 320px;" src="@/assets/images/index/no-points.png" >
      </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
.container {
  margin-top: 100px;
}
</style>